import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const paginate = (items, page, pageSize) => {
  const maxPage = Math.max(1, Math.ceil(items.length / pageSize));
  const safe = Math.min(page, maxPage);
  return items.slice((safe - 1) * pageSize, safe * pageSize);
};

export default function PaginationControls({ total, page, pageSize, onPageChange, onPageSizeChange, testId = 'pagination' }) {
  const maxPage = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, maxPage);
  if (total <= 25 && safePage === 1) return null;
  const from = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, total);
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-2 py-3 border-t" data-testid={testId}>
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <span data-testid={`${testId}-summary`}>Showing {from}–{to} of {total}</span>
        <select
          className="border rounded-md px-2 py-1 text-sm bg-background"
          value={pageSize}
          onChange={(e) => { onPageSizeChange(parseInt(e.target.value)); onPageChange(1); }}
          data-testid={`${testId}-page-size`}
        >
          <option value={25}>25 / page</option>
          <option value={50}>50 / page</option>
          <option value={100}>100 / page</option>
        </select>
      </div>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)} data-testid={`${testId}-prev`}>
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="text-sm px-3" data-testid={`${testId}-page-info`}>Page {safePage} of {maxPage}</span>
        <Button variant="outline" size="sm" disabled={safePage >= maxPage}
          onClick={() => onPageChange(safePage + 1)} data-testid={`${testId}-next`}>
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
